module.exports = __webpack_public_path__ + "static/media/patient-avatar-3.fb17c0c1.svg";